import Axios from 'axios';
import storageAvailable from '../../helpers/storage_available';
import { fetchData } from '../../helpers/base_data_fetcher';

const updatedExperiments = [];

async function reportExperiments(experimentArray) {
  // eslint-disable-next-line no-restricted-syntax
  for (const experiment of experimentArray) {
    const variation = parseInt(experiment.variation, 10);
    if (experiment.recorded) {
      updatedExperiments.push(experiment);
    }
    // eslint-disable-next-line no-restricted-globals
    if (!isNaN(variation) && !experiment.recorded) {
      try {
        // eslint-disable-next-line no-await-in-loop
        await Axios.post('/api/1.0/user-experiments-variations', {
          name: experiment.id,
          variation: variation.toString(),
          first_seen: experiment.first_seen,
        });
        experiment.recorded = true;
        updatedExperiments.push(experiment);
      } catch (err) {
        if (err.response.status == 409) {
          // Set the experiment as seen to avoid duplicate requests
          experiment.recorded = true;
          updatedExperiments.push(experiment);
        }
      }
    }
  }
  return localStorage.setItem(
    'experiment-variation',
    JSON.stringify(updatedExperiments),
  );
}

const registerUserExperiments = async () => {
  if (!storageAvailable('localStorage')) {
    return;
  }
  try {
    const loggedIn = await fetchData('session.loggedin');
    const allRecordedExperiments = JSON.parse(
      localStorage.getItem('experiment-variation'),
    );
    if (allRecordedExperiments) {
      await reportExperiments(allRecordedExperiments);
    }
  } catch (error) {
    //
  }
};

export default registerUserExperiments;
